import { render, staticRenderFns } from "./BaggageAbnormalCheckIn.vue?vue&type=template&id=221e4f60&scoped=true&"
import script from "./BaggageAbnormalCheckIn.vue?vue&type=script&lang=js&"
export * from "./BaggageAbnormalCheckIn.vue?vue&type=script&lang=js&"
import style0 from "./BaggageAbnormalCheckIn.vue?vue&type=style&index=0&id=221e4f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221e4f60",
  null
  
)

export default component.exports